import {SimpleNavigation} from '../../app-common/services/navigation.service';
import {RandomStringGenerator} from '../../app-common/utils/random-string.generator';
import {Routes} from "@angular/router";

export class Tab {
  id: string;
  header: string;
  icon: string;
  navigationData: SimpleNavigation;

  static getDefault(): Tab {
    const tab = new Tab();
    tab.id = RandomStringGenerator.generateString(16, {letters: true, includeUppercase: true});
    tab.header = 'Home';
    tab.icon = 'fas fa-home';
    tab.navigationData = SimpleNavigation.getDefault();
    return tab;
  }
}
